
import { useSelector } from 'react-redux'
import { campaignDateInfo, isCampaignActive, teaserCampaignDateInfo } from 'utils/dateUtils'
import { shoppingCartSelector } from 'store/selectors/dataView/dataView.productsListFinal.selector'
import blackFridayImage from 'assets/Campaign/blackFriday.webp'

import black_friday_dashboard_slide from 'assets/Campaign/black_friday_dashboard_slide.png'
import black_friday_homepage_slide from 'assets/Campaign/black_friday_homepage_slide.png'
import black_friday_dashboard_slide2 from 'assets/Campaign/black_friday_dashboard_slide2.png'
import black_friday_homepage_slide2 from 'assets/Campaign/black_friday_homepage_slide2.png'
import black_friday_2025_teaser from 'assets/Campaign/black_friday_2025_teaser_dashboard.png'
import black_friday_2025_campaign from 'assets/Campaign/black_friday_2025_campaign_dashboard.png'

import useIsLogged from 'utils/useIsLogged'
import { getBfListUrl } from 'config/blackFriday2026'
import { ENABLE_NON_LOGGED_BLACK_FRIDAY_PRICES, ENABLE_FLOATING_BUTTON_DURING_CAMPAIGN } from 'config/campaignFeatureToggles'


const useCampaignInfo = () => {
  
  const campaignApiInfo = useSelector(state => state?.shop?.campaignApiInfo)
  const shoppingCart = useSelector(shoppingCartSelector)
  const isShoppingCartEmpty = !Boolean(shoppingCart?.products?.[0]?.length)
  const isLogged = useIsLogged()

  const getShouldShowCampaignCheckbox = () => {
      if(!isCampaignActive()) return false
      if(!campaignConfig.doesAffectCart) return false
      if(isShoppingCartEmpty) return false
      if(campaignApiInfo?.isCompanyInCampaign) return false
      return true
  }

  const getInitialCampaignCheckboxState = () => {
      if(!isCampaignActive()) return false
      if(campaignApiInfo?.isUserInCampaign) return true
      return false
  }

  const getShouldShowFloatingButton = () => {
    if(isLogged) return false
    // The floating button visibility is now controlled by the feature toggle.
    // When enabled, it shows DURING and AFTER the campaign (not before).
    return campaignConfig.shouldShowFloatingButton
  }

  return {
    /** campaignApiInfo?.isUserInCampaign is a misleading name.
     * It actually becomes false if the user REFUSED the campaign
     * in the past. Meant to be used to decide the initial state
     * of the campaign-related checkbox. */
    initialCampaignCheckboxState: getInitialCampaignCheckboxState(),
    shouldShowCampaignCheckbox: getShouldShowCampaignCheckbox(),
    shouldShowFloatingButton: getShouldShowFloatingButton(),

  }

}


/**
 * The campaign ended but SOME of its implemented functionalities 
 * must stay active for some more time. This function is the 
 * decision point for those.
 */
export const isCampaignPartiallyActive = () => 
  true

const getBannerUrl = () => {
  if(campaignDateInfo.isBeforeCampaign) return ''

  return campaignDateInfo.isCampaignActive
    ? getBfListUrl()
    : 'https://uniprest.ro/promotii/'

}

const getFloatingUrl = () => {
  return campaignDateInfo.isCampaignActive
    ? getBfListUrl()
    : 'https://uniprest.ro/promotii/'
}


export const campaignConfig = {
  url: getBannerUrl(),
  floatingButtonUrl: getFloatingUrl(),
  name: campaignDateInfo.isCampaignActive ? 'Black Friday' : 'Promoții',
  doesAffectRouting: false,
  doesAffectCart: false,
  imageUrl: blackFridayImage,
  homepageSlideImage: campaignDateInfo.isBeforeCampaign ? black_friday_homepage_slide : black_friday_homepage_slide2,
  dashboardSlideImage: campaignDateInfo.isCampaignActive ? black_friday_2025_campaign : black_friday_dashboard_slide2,
  homepageLocalizationKey: campaignDateInfo.isBeforeCampaign ? 'home.slider2_black_friday_description' : 'home.slider2_black_friday_description2',
  dashboardLocalizationKey: campaignDateInfo.isBeforeCampaign ? 'dashboard.blackFridayLabel' : 'dashboard.blackFridayLabel2',
  hasNarrowDashboardBanner: false,
  isBeforeCampaign: campaignDateInfo.isBeforeCampaign,
  isAfterCampaign: campaignDateInfo.isAfterCampaign,
  isCampaignActive: campaignDateInfo.isCampaignActive,
  isHomepageSlideActive: campaignDateInfo.isCampaignActive || campaignDateInfo.isBeforeCampaign,
  shouldHideOtherHomepageSlides: campaignDateInfo.isCampaignActive || campaignDateInfo.isBeforeCampaign,
  shouldInsertDashboardSlide: false,
  // 2026: no campaign slide from the client yet, the dashboard keeps its slider
  shouldReplaceDashboardSlider: false,
  shouldDisplayNonLoggedPrices: campaignDateInfo.isCampaignActive && ENABLE_NON_LOGGED_BLACK_FRIDAY_PRICES,
  shouldHideStockLiquidationCatFilter: campaignDateInfo.isCampaignActive,
  shouldHideBlackFridayCatFilter: !campaignDateInfo.isCampaignActive,
  shouldShowBlackFridayLabels: campaignDateInfo.isCampaignActive,
  shouldDarkenFloatingButton: campaignDateInfo.isCampaignActive,
  shouldShowBreadcrumbExplanation: campaignDateInfo.isCampaignActive,
  shouldShowFloatingButton: !campaignDateInfo.isBeforeCampaign && ENABLE_FLOATING_BUTTON_DURING_CAMPAIGN,
}

export const teaserCampaignConfig = {
  shouldShowTeaserSlide: teaserCampaignDateInfo.isCampaignActive,
  shouldReplaceDashboardSlider: teaserCampaignDateInfo.isCampaignActive,
  dashboardSlideImage: black_friday_2025_teaser,
  url: ''
}

export default useCampaignInfo


export const GoToCampaign = () => {

  window.location.href = 'https://uniprest.ro/black-friday/'

  return null

}